import { Link } from 'react-router-dom'

import { useLogout } from '@/api/useLogout'
import { PageHeader, useNavTree } from '@/components/layout'
import { Icon } from '@/components/ui'

const row =
  'flex min-h-14 w-full items-center gap-3 px-4 text-left text-[15px] text-fg active:bg-surface-2 hover:bg-surface-2'

/** «Ещё» на телефоне: всё, что не поместилось в нижнюю панель. */
export function MorePage() {
  const nav = useNavTree()
  const logout = useLogout()
  return (
    <>
      <PageHeader title="Ещё" />
      <ul className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-surface">
        {nav.more.map((item) => (
          <li key={item.path}>
            <Link to={item.path} className={row}>
              <Icon name={item.icon} size={20} className="text-muted" />
              <span className="min-w-0 flex-1 truncate">{item.label}</span>
              <Icon name="chevron-right" size={18} className="text-muted" />
            </Link>
          </li>
        ))}
        <li>
          <button type="button" className={row} onClick={() => logout.mutate()} disabled={logout.isPending}>
            <Icon name="logout" size={20} className="text-muted" />
            <span className="flex-1">Выйти</span>
          </button>
        </li>
      </ul>
    </>
  )
}
